// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.CategoryItem-allCategoryListItemBox-cXe0b {
  width: 100%;
  max-width: 155px;
  margin: 0 auto;
  text-align: center;
}

.CategoryItem-allCategoryListItemImgContainer-LmFAU {
  position: relative;
  width: 100%;
  max-width: 136px;
  height: 136px;
  border-radius: 0 var(--radius-2) 0 var(--radius-2);
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-pack: center;
      -ms-flex-pack: center;
          justify-content: center;
  -webkit-box-align: center;
      -ms-flex-align: center;
          align-items: center;
  background: var(--category-bg);
  border: 1px solid var(--primary-border);
  margin: 0 auto;
}

.CategoryItem-allCategoryListItemInfo-jBy_W {
  font-size: 18px;
  font-weight: 600;
  line-height: 28px;
  color: var(--primary-foreground);
  margin-top: 18px;
}

.CategoryItem-allCategoryListItemImgWrapper-JVxbB {
  position: relative;
  width: 80px;
  height: 80px;
}

.CategoryItem-allCategoryListItemImgWrapper-JVxbB img {
  position: absolute;
  inset: 0;
  width: 100%;
  height: 100%;
  -o-object-fit: contain;
     object-fit: contain;
}

@media (min-width: 1200px) {
  .CategoryItem-allCategoryListItemImgContainer-LmFAU::before {
    content: '';
    position: absolute;
    top: 3px;
    left: -9px;
    background: transparent;
    width: 100%;
    height: 142px;
    border-radius: inherit;
    z-index: -1;
  }

  .CategoryItem-allCategoryListItemBox-cXe0b:hover .CategoryItem-allCategoryListItemImgContainer-LmFAU::before {
    background: var(--category-hover);
  }
}

@media (max-width: 767px) {
  .CategoryItem-allCategoryListItemInfo-jBy_W {
    font-size: 16px;
    line-height: 26px;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/search/CategoryItem/CategoryItem.css"],"names":[],"mappings":"AAAA;EACE,WAAW;EACX,gBAAgB;EAChB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,gBAAgB;EAChB,aAAa;EACb,kDAAkD;EAClD,oBAAa;EAAb,oBAAa;EAAb,aAAa;EACb,wBAAuB;MAAvB,qBAAuB;UAAvB,uBAAuB;EACvB,yBAAmB;MAAnB,sBAAmB;UAAnB,mBAAmB;EACnB,8BAA8B;EAC9B,uCAAuC;EACvC,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,gCAAgC;EAChC,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,WAAW;EACX,YAAY;EACZ,sBAAmB;KAAnB,mBAAmB;AACrB;;AAEA;EACE;IACE,WAAW;IACX,kBAAkB;IAClB,QAAQ;IACR,UAAU;IACV,uBAAuB;IACvB,WAAW;IACX,aAAa;IACb,sBAAsB;IACtB,WAAW;EACb;;EAEA;IACE,iCAAiC;EACnC;AACF;;AAEA;EACE;IACE,eAAe;IACf,iBAAiB;EACnB;AACF","sourcesContent":[".allCategoryListItemBox {\n  width: 100%;\n  max-width: 155px;\n  margin: 0 auto;\n  text-align: center;\n}\n\n.allCategoryListItemImgContainer {\n  position: relative;\n  width: 100%;\n  max-width: 136px;\n  height: 136px;\n  border-radius: 0 var(--radius-2) 0 var(--radius-2);\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  background: var(--category-bg);\n  border: 1px solid var(--primary-border);\n  margin: 0 auto;\n}\n\n.allCategoryListItemInfo {\n  font-size: 18px;\n  font-weight: 600;\n  line-height: 28px;\n  color: var(--primary-foreground);\n  margin-top: 18px;\n}\n\n.allCategoryListItemImgWrapper {\n  position: relative;\n  width: 80px;\n  height: 80px;\n}\n\n.allCategoryListItemImgWrapper img {\n  position: absolute;\n  inset: 0;\n  width: 100%;\n  height: 100%;\n  object-fit: contain;\n}\n\n@media (min-width: 1200px) {\n  .allCategoryListItemImgContainer::before {\n    content: '';\n    position: absolute;\n    top: 3px;\n    left: -9px;\n    background: transparent;\n    width: 100%;\n    height: 142px;\n    border-radius: inherit;\n    z-index: -1;\n  }\n\n  .allCategoryListItemBox:hover .allCategoryListItemImgContainer::before {\n    background: var(--category-hover);\n  }\n}\n\n@media (max-width: 767px) {\n  .allCategoryListItemInfo {\n    font-size: 16px;\n    line-height: 26px;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"allCategoryListItemBox": `CategoryItem-allCategoryListItemBox-cXe0b`,
	"allCategoryListItemImgContainer": `CategoryItem-allCategoryListItemImgContainer-LmFAU`,
	"allCategoryListItemInfo": `CategoryItem-allCategoryListItemInfo-jBy_W`,
	"allCategoryListItemImgWrapper": `CategoryItem-allCategoryListItemImgWrapper-JVxbB`
};
module.exports = ___CSS_LOADER_EXPORT___;
